
export function urlGetParams(location, name) {

    return urlGetAllParams( location )[ name ] || false
}



export function urlGetAllParams(location) {
    var qs = (location.search.length > 0 ? location.search.substring(1) : ""),
        args = {},
        items = qs.length ? qs.split("&") : [],
        item = null,
        name = null,
        value = null,
        i = 0,
        len = items.length;
    for (i = 0; i < len; i++) {
        item = items[i].split("=");
        name = decodeURIComponent(item[0]);
        value = decodeURIComponent(item[1]);
        if (name.length && value) {
            args[name] = value;
        }
    }
    return args;
}

export function urlGetParamsV0(name) { 
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)","i"); 
    var r = window.location.search.substr(1).match(reg); 
    if (r!=null){
        return (r[2]);
    }
    return null; 
}



// WEBPACK FOOTER //
// ./common/lib/url.js